<div
  [innerHtml]="iconSource"
  #iconWrapper></div>